import { render, staticRenderFns } from "./IDCard.vue?vue&type=template&id=59a55ee2&scoped=true&"
import script from "./IDCard.vue?vue&type=script&lang=js&"
export * from "./IDCard.vue?vue&type=script&lang=js&"
import style0 from "./IDCard.vue?vue&type=style&index=0&id=59a55ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a55ee2",
  null
  
)

export default component.exports